import loadable from '@loadable/component'

export const Podcast = loadable(() => import('./Podcast'))
export const PodcastBanner = loadable(() => import('./PodcastBanner'))
export const PodcastList = loadable(() => import('./PodcastList'))
export const PodcastListItem = loadable(() => import('./PodcastListItem'))
export const PodcastPlayerSeries = loadable(
  () => import('./PodcastPlayerSeries')
)
export const PodcastSeries = loadable(() => import('./PodcastSeries'))
export const PodcastSeriesHead = loadable(() => import('./PodcastSeriesHead'))
export const PodcastSeriesItem = loadable(() => import('./PodcastSeriesItem'))
export const Podcasts = loadable(() => import('./Podcasts'))
export type { PodcastProps } from './Podcast'
export type { PodcastListProps } from './PodcastList'
export type { PodcastListItemProps } from './PodcastListItem'
export type { PodcastPlayerSeriesProps } from './PodcastPlayerSeries'
export type { PodcastSeriesProps } from './PodcastSeries'
export type { PodcastSeriesItemProps } from './PodcastSeriesItem'
export type { PodcastsProps } from './Podcasts'
